import { render, staticRenderFns } from "./narrative-modal.vue?vue&type=template&id=5204f0cf"
import script from "./narrative-modal.vue?vue&type=script&lang=js"
export * from "./narrative-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports